import React from 'react';
import { AspectRatioName } from 'types';
import {
  getAspectRatioDimensions,
  getAspectRatioNameFromRatio,
  getAspectRatioValue,
} from 'utils/aspect-ratio';

export type UploadDimensionsRecommendationProps = {
  aspectRatio: AspectRatioName | number;
};

const ASPECT_RATIO_DIMENSIONS = {
  landscape: '1920 ✕ 1080',
  portrait: '1080 ✕ 1920',
  square: '1080 ✕ 1080',
};

const UploadDimensionsRecommendation: React.FC<UploadDimensionsRecommendationProps> = ({
  aspectRatio,
}) => {
  const ratioValue =
    typeof aspectRatio === 'number'
      ? aspectRatio
      : getAspectRatioValue(aspectRatio);

  const ratioName =
    typeof aspectRatio === 'number'
      ? getAspectRatioNameFromRatio(aspectRatio)
      : aspectRatio;

  const aspectRatioSimplestForm = getAspectRatioDimensions(ratioValue);

  const simplestFormWidth = aspectRatioSimplestForm.get('width');
  const simplestFormHeight = aspectRatioSimplestForm.get('height');

  const dimensions = `${ASPECT_RATIO_DIMENSIONS[ratioName]} PX`;
  const ratio = `${simplestFormWidth}:${simplestFormHeight}`;

  return !ratioName ? null : (
    <>
      {dimensions}&nbsp;&nbsp;/&nbsp;&nbsp;{ratio}
    </>
  );
};

export default UploadDimensionsRecommendation;
